import { returnProductDataLayerObject } from '.';

export const pushProductClickToDataLayer = (product) => {
  const dataLayerData = {
    event: 'productClick',
    ecommerce: {
      products: [],
    },
  };

  dataLayerData.ecommerce.products.push(returnProductDataLayerObject(product));

  if (typeof dataLayer === 'undefined') {
    return;
  }

  dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  dataLayer.push(dataLayerData);
};
